



const Portfolio = () => {




    return (
		<div className="main-table"><div className="title-center"><h4>Day I &nbsp;&nbsp;&nbsp;Dec. 10th</h4></div>
<table className="sessions">
<tr> <th> Session Time </th><th>Qingshui Bay</th>
<th>Xiangshui Bay</th>
<th>Online Room 1</th>
<th>Online Room 2</th>
 </tr><tr> <th>11:20-11:40</th> <td> <p className="table-id"> No. #2987</p>
 <p className="table-title">Proximal policy optimization for same-day delivery with drones and vehicles</p>
 <p className="table-authors">Meng Li, Kaiquan Cai and Peng Zhao</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr><tr> <th>11:40-12:00</th> <td> <p className="table-id"> No. #9139</p>
 <p className="table-title">PEKD: Joint Prompt-tuning and Ensemble Knowledge Distillation Framework for Causal Event Detection from Biomedical Literature</p>
 <p className="table-authors">Xiaoyu Li, Haonan Liu, Li Jin, Gege Li and Shichang Guan</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr><tr> <th>13:30-13:50</th> <td> <p className="table-id"> No. #1739</p>
 <p className="table-title">Forecasting Chinese Overnight Stock Index Movement Using Large Language Models with Market Summary</p>
 <p className="table-authors">Haiping Wang and Xin Zhou</p></td>
<td> <p className="table-id"> No. #5936</p>
 <p className="table-title">A Local Interpretability Model-based Approach for Black-box Adversarial Attack</p>
 <p className="table-authors">Yuanjie Duan, Xingquan Zuo, Hai Huang, Binglin Wu and Xinchao Zhao</p></td>
<td> <p className="table-id"> No. #6184</p>
 <p className="table-title">Integrated Patient Care Optimization Model: A Novel Model to Enhancing Medical Alliance Efficiency</p>
 <p className="table-authors">Hong Wang, Xinyu Li, Xiaolong Ou, Yaofa Su and Zhifu Zhang</p></td>
<td> <p className="table-id"> No. #1090</p>
 <p className="table-title">Construction of Digital Twin Battlefield with Command and Control as the Core</p>
 <p className="table-authors">Fang Wang, Ling Ye, Shaoqiu Zheng, Haiqing Wang, Chenyu Huang and Lingyun Lu</p></td>
</tr><tr> <th>13:50-14:10</th> <td> <p className="table-id"> No. #7049</p>
 <p className="table-title">Comparison of Prediction Methods on Large-Scale and Long-Term Online Live Streaming Data</p>
 <p className="table-authors">Huan Chen, Shuhui Guo, Siyu Lai and Xin Lu</p></td>
<td> <p className="table-id"> No. #5975</p>
 <p className="table-title">FirewaLLM: A Portable Data Protection and Recovery Framework for LLM Services</p>
 <p className="table-authors">Bin Huang, Shiyu Yu, Jin Li, Yuyang Chen, Shaozheng Huang, Sufen Zeng and Shaowei Wang</p></td>
<td> <p className="table-id"> No. #6014</p>
 <p className="table-title">AL-SQUARES:SQL Synthesis System with the Addition of Reducer</p>
 <p className="table-authors">Huimin Liu, Quansheng Dou and Huixian Wang</p></td>
<td> <p className="table-id"> No. #7925</p>
 <p className="table-title">A Joint Method for Combat Intent Recognition and Key Information Extraction</p>
 <p className="table-authors">Jinhao Zhang, Guoxin Jiang, Lingyun Lu, Chi Yuan, Haoqian Zhang and Shaoqiu Zheng</p></td>
</tr><tr> <th>14:10-14:30</th> <td> <p className="table-id"> No. #4413</p>
 <p className="table-title">Ant-antlion Optimizer with Similarity Information for Multidimensional Knapsack Problem</p>
 <p className="table-authors">Yi Liu, Guoli Yang, Qibin Zheng, Xiang Li, Kun Liu, Qiang Wang and Wei Qin</p></td>
<td> <p className="table-id"> No. #8945</p>
 <p className="table-title">Review of Machine Learning Algorithms for Breast Cancer Diagnosis</p>
 <p className="table-authors">Man Chen, Wuyue Fan, Weiye Tang, Tianhao Liu, Daren Li and Omar Dib</p></td>
<td> <p className="table-id"> No. #7340</p>
 <p className="table-title">No-reference quality assessment for HDR images based on multi-scale Retinex decomposition</p>
 <p className="table-authors">Donghui Wan, Yehui Liu, Xiuhua Jiang, Hongtao Yang, Ling Lei and Jiaxing Liu</p></td>
<td> <p className="table-id"> No. #9709</p>
 <p className="table-title">Theory-assisted Deep Learning Weapon System Combat Effectiveness Prediction</p>
 <p className="table-authors">Jiahao Zhou, Xuekang Yang, Weiran Guo, Xiang Huang and Jie Zhang</p></td>
</tr><tr> <th>14:30-14:50</th> <td> <p className="table-id"> No. #4033</p>
 <p className="table-title">Many-Constraint Multi-Objective Optimization of Grid-Connected Hybrid Renewable Energy System</p>
 <p className="table-authors">Mengjun Ming, Xin Zhou, Rui Wang and Tao Zhang</p></td>
<td> <p className="table-id"> No. #9329</p>
 <p className="table-title">A Two-stage Approach to Optimize Medical Waste Transportation Problem under Emergency Condition</p>
 <p className="table-authors">Hong Wang, Xuan Zhang, Jinxin Zhang and Ben Niu</p></td>
<td> <p className="table-id"> No. #7980</p>
 <p className="table-title">Query Reverse Engineering of Pre-deleted Uncorrelated Operators</p>
 <p className="table-authors">Quansheng Dou, Huixian Wang, Huanling Tang, Hao Pan and Shun Zhang</p></td>
<td> <p className="table-id"> No. #6572</p>
 <p className="table-title">Cross-Language Text Search Algorithm Based on Context-Compatible Algorithms</p>
 <p className="table-authors">Sheng Jianqiao, Liang Zhang, Xiyin Wang, Xu Run and Jiaqi Wu</p></td>
</tr><tr> <th>14:50-15:10</th> <td> <p className="table-id"> No. #7854</p>
 <p className="table-title">Efficient Graph Sequence Reinforcement Learning for Traveling Salesman Problem</p>
 <p className="table-authors">Yiyang Liu and Lin Li</p></td>
<td> <p className="table-id"> No. #5964</p>
 <p className="table-title">A Deep Convolutional Neural Network Based Approach for Automatic Detection of Diabetic Retinopathy</p>
 <p className="table-authors">Waqas Haider Bangyal, Rabia Shakir, Adnan Ashraf and Jamil Ahmad</p></td>
<td> <p className="table-id"> No. #8676</p>
 <p className="table-title">Node Importance-based Semi-supervised Nonnegative Matrix Factorization for Image Clustering</p>
 <p className="table-authors">Jintao Wu and Youlong Yang</p></td>
<td> <p className="table-id"> No. #6614</p>
 <p className="table-title">Empirical analysis on the effectiveness of pre-trained models in the identification of physical violence against women in videos for a multi-class approach</p>
 <p className="table-authors">Itzel Abundez, Grisel Miranda-Piña, Roberto Alejo, E. Everardo Granda-Gutiérrez, Alejandro Cisniega and Otniel Portillo-Rodríguez</p></td>
</tr><tr> <th>15:30-15:50</th> <td> <p className="table-id"> No. #3583</p>
 <p className="table-title">Aerial Scene Understanding based on Synthetic Data</p>
 <p className="table-authors">Zhiyuan Zhao and Ke Xie</p></td>
<td> <p className="table-id"> No. #9513</p>
 <p className="table-title">An Empirical Study on the Impact of Environmental Policies on Green Total Factor Productivity of Manufacturing Industry in China</p>
 <p className="table-authors">Cui Yanru, Wu Mingran, Wang Tao and Ming Mengjun</p></td>
<td> <p className="table-id"> No. #3102</p>
 <p className="table-title">Data Analytics Methods in Human Resource Demand Forecasting</p>
 <p className="table-authors">Wei Wang, Jin Zhu and Pingxin Wang</p></td>
<td> <p className="table-id"> No. #2165</p>
 <p className="table-title">A New Deep Reinforcement Learning Algorithm for UAV Swarm Confrontation Game</p>
 <p className="table-authors">Laicai Xie, Wanpeng Ma, Liping Wang and Liangjun Ke</p></td>
</tr><tr> <th>15:50-16:10</th> <td> <p className="table-id"> No. #4432</p>
 <p className="table-title">A New Approach for Ontology Generation from Relational Data Design Patterns</p>
 <p className="table-authors">Xiang Li, Luo Rui, Kun Liu, Fan Li, Chengjun Wang and Qiang Wang</p></td>
<td> <p className="table-id"> No. #514</p>
 <p className="table-title">Research on Data Mining Methods in the Field of Quality Problem Analysis Based on BERT Model</p>
 <p className="table-authors">Zihuan Ding and Guangyan Zhao</p></td>
<td> <p className="table-id"> No. #5107</p>
 <p className="table-title">A Localization Correction Algorithm of Location-based Services Based on Point Clustering</p>
 <p className="table-authors">Jianqiao Sheng, Liang Zhang, Yicao Zhang, Jingxuan Xu and Jiaqi Wu</p></td>
<td> <p className="table-id"> No. #9511</p>
 <p className="table-title">A Double-Layer Reinforcement Learning Feature Optimization Framework for Evolutionary Computation based Feature Selection Algorithms</p>
 <p className="table-authors">Hong Wang, Yaofa Su, Xiaolong Ou, Jinxin Zhang and Ben Niu</p></td>
</tr><tr> <th>16:10-16:30</th> <td> <p className="table-id"> No. #5600</p>
 <p className="table-title">Mining Maximal High Utility Co-Location Patterns from Large-Scale Spatial Data</p>
 <p className="table-authors">Muquan Zou, Vanha Tran, Ducanh Khuat, Thanhcong Do and Jinpeng Zhang</p></td>
<td> <p className="table-id"> No. #8109</p>
 <p className="table-title">Assessing GPT-4 Generated Abstracts: Text Relevance and Detectors Based on Faithfulness, Expressiveness, and Elegance Principle</p>
 <p className="table-authors">Bixuan Li, Qifu Chen, Jinlin Lin, Sai Li and Jerome Yen</p></td>
<td> <p className="table-id"> No. #7141</p>
 <p className="table-title">A Practical Byzantine Fault Tolerance Algorithms Based on Randomized Mean Clustering, Trust and Credibility</p>
 <p className="table-authors">Zhai Haonan and Tong Xiangrong</p></td>
<td>  </td>
</tr><tr> <th>16:30-16:50</th> <td> <p className="table-id"> No. #6423</p>
 <p className="table-title">A Service-Oriented Data Sharing and Exchange Model</p>
 <p className="table-authors">Qian Li, Xinyu Jiang, Jianwei Sun, Hongyu Guo, Yulong Liu, Zi Wang and Dan Liu</p></td>
<td> <p className="table-id"> No. #8200</p>
 <p className="table-title">Financial Text Sentiment Analysis Based on ChatGPT-Taking the Real Estate Industry as an Example</p>
 <p className="table-authors">Jinlin Lin, Qifu Chen, Sai Li, Bixuan Li and Jerome Yen</p></td>
<td> <p className="table-id"> No. #9854</p>
 <p className="table-title">Improved Joint Distribution Adaptation for Fault Diagnosis</p>
 <p className="table-authors">Dali Gao, Xiaobin Mao, Long Sheng and Shuangling Wang</p></td>
<td>  </td>
</tr><tr> <th>16:50-17:10</th> <td> <p className="table-id"> No. #7900</p>
 <p className="table-title">Research on the Meta Synthesis Model of Strategic Risk Management for the Complex Weapon Equipment Systems Development</p>
 <p className="table-authors">Xinfeng Wang and Tao Wang</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr><tr> <th>17:10-17:30</th> <td> <p className="table-id"> No. #9922</p>
 <p className="table-title">Integrated Organization and Sharing Method and Platform for AI Computing Resources based on Digital Object</p>
 <p className="table-authors">Yi-Shuai Zhao, Zhi-Hui Ma, Shan Jiang and Kun Liu</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr></table>
</div>

		
    )
}

export default Portfolio